import {
  RoleSchema,
  sameSessionContext,
  type SessionContext,
  type UserMembership,
} from "../types/user.js";
import { sessionContextKindOf } from "./sessionContextKindOf.js";

/**
 * Every session context the memberships allow, in the order their
 * organisations first appear, each combining the roles of its kind held there.
 * Roles are listed in `RoleSchema`'s order, so two sessions holding the same
 * roles describe them identically.
 */
export const sessionContextsFromMemberships = (
  memberships: readonly UserMembership[],
): SessionContext[] => {
  const contexts: SessionContext[] = [];

  for (const membership of memberships) {
    const kind = sessionContextKindOf(membership.role);
    const existing = contexts.find((context) =>
      sameSessionContext(context, {
        organisationId: membership.organisationId,
        kind,
      }),
    );

    if (existing === undefined) {
      contexts.push({
        organisationId: membership.organisationId,
        kind,
        roles: [membership.role],
        ...(membership.organisationName === undefined
          ? {}
          : { organisationName: membership.organisationName }),
      });
    } else {
      existing.roles = RoleSchema.options.filter(
        (role) => role === membership.role || existing.roles.includes(role),
      );
    }
  }

  return contexts;
};
